var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIveco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_400",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29222",
    "data-name": "Group 29222",
    transform: "translate(138 10411)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -138, -10411)",
    filter: "url(#Ellipse_400)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_400-2",
    "data-name": "Ellipse 400",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "IVECO",
    transform: "translate(-126 -10402)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8465",
    "data-name": "Rectangle 8465",
    width: 3,
    height: 10,
    rx: 0.5,
    transform: "translate(2 19)",
    fill: "#0b447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50579",
    "data-name": "Path 50579",
    d: "M7.457,19H9.284a.479.479,0,0,1,.44.4l1.294,5.5a.449.449,0,0,0,.878,0l1.294-5.5a.479.479,0,0,1,.439-.4h.914a.538.538,0,0,1,.446.676L13.431,27.9A1.341,1.341,0,0,1,12.122,29H9.878a1.341,1.341,0,0,1-1.309-1.1L7.011,19.68A.538.538,0,0,1,7.457,19Z",
    fill: "#0b447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50580",
    "data-name": "Path 50580",
    d: "M25,19.556v1.111a.564.564,0,0,1-.571.555H21a.563.563,0,0,0-.571.556v1.111h2.857a.564.564,0,0,1,.571.555v1.112a.564.564,0,0,1-.571.555H20.429v1.111a.563.563,0,0,0,.571.556h3.429a.564.564,0,0,1,.571.555v1.111a.564.564,0,0,1-.571.556H18.143A1.127,1.127,0,0,1,17,27.889V20.111A1.127,1.127,0,0,1,18.143,19h6.286A.564.564,0,0,1,25,19.556Z",
    fill: "#0b447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50581",
    "data-name": "Path 50581",
    d: "M34.429,19h-4A3.382,3.382,0,0,0,27,22.333v3.334A3.382,3.382,0,0,0,30.429,29h4A.564.564,0,0,0,35,28.444V27.333a.564.564,0,0,0-.571-.555H31.571a1.127,1.127,0,0,1-1.142-1.111V22.333a1.127,1.127,0,0,1,1.142-1.111h2.858A.564.564,0,0,0,35,20.667V19.556A.564.564,0,0,0,34.429,19Z",
    fill: "#0b447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50582",
    "data-name": "Path 50582",
    d: "M43,19H41a4.24,4.24,0,0,0-4,4.444v1.112A4.24,4.24,0,0,0,41,29h2a4.24,4.24,0,0,0,4-4.444V23.444A4.24,4.24,0,0,0,43,19Zm1,5.556a2.011,2.011,0,1,1-4,0V23.444a2.011,2.011,0,1,1,4,0Z",
    fill: "#0b447c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIveco);
export default __webpack_public_path__ + "static/media/iveco.27446cb79a0cc0170a87aaddab73e72d.svg";
export { ForwardRef as ReactComponent };